import {PmDocumentStatus} from '../models/pmReview.types'

export const formatCurrencyPerWeek = (value: number): string =>
  `$${new Intl.NumberFormat('en-AU').format(value)}/wk`

export const formatPmDate = (value?: string): string => {
  if (!value) {
    return 'Not available'
  }

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return 'Not available'
  }

  return new Intl.DateTimeFormat('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parsed)
}

export const formatReceivedAt = (value?: string): string => {
  if (!value) {
    return 'Not available'
  }

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return 'Not available'
  }

  const date = new Intl.DateTimeFormat('en-AU').format(parsed)
  const time = new Intl.DateTimeFormat('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(parsed)

  return `${date} ${time}`
}

export const obfuscateToken = (token: string): string => {
  const normalized = token.trim()
  if (normalized.length <= 8) {
    return normalized || 'Unavailable'
  }

  return `${normalized.slice(0, 4)}...${normalized.slice(-4)}`
}

export const toDocumentStatusLabel = (status: PmDocumentStatus): string => {
  if (status === 'not-required') {
    return 'Not required'
  }

  return status.charAt(0).toUpperCase() + status.slice(1)
}

const formatTypeText = (text: string) => {
  return text.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

export const getDocumentTypeLabel = (type?: string): string => {
  if (!type) return 'Unknown'

  if (type.startsWith('identity')) {
    const typename = type.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
    return 'ID ' + (typename.trim().split(' ').pop() || '')
  }

  /*if (type.startsWith('income')) {
    return 'Income'
  }

  return type.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
*/
  return formatTypeText(type)
}

export const getDocumentContentTypeLabel = (mimeType?: string): string => {
  if (!mimeType) return 'Unknown'

  if (mimeType.startsWith('image/')) {
    return 'Image'
  }

  if (mimeType === 'application/pdf') {
    return 'PDF document'
  }

  return 'Document'
}

export const formatMoney = (value: number): string =>
  `$${Math.max(0, Math.round(value)).toLocaleString('en-AU')}`

export const formatMonthYear = (value?: string): string => {
  if (!value) {
    return 'Not available'
  }

  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return 'Not available'
  }

  return new Intl.DateTimeFormat('en-AU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parsed)
}
